module.exports = __webpack_public_path__ + "img/info-card-icon.c90bee82.svg";